module.exports = __webpack_public_path__ + "img/1tZ1CW4Uu9tKArjfCHVt9stltZKjcz0Cr.2d96227d.jpg";